import DashboardLayout from 'components/layout/dashboard/DashboardLayout';
import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import './transactionById.css';
import AuthContext from 'contexte/AuthContext';
import { launchError } from 'components/notifications';
import Notification from 'components/notifications/Notification';
import { formatDate } from 'utils/date';
import Badge from 'components/Badge/Badge';
import colors from 'assets/colors';
import { fetchTransactionDetails } from 'services/transactionsServices';
import { getDecimalValue } from 'utils/numbers';

const TransactionById = () => {

  const [loading, setLoading] = useState(true)
  const [dataset, setDataset] = useState([])

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const params = useParams();



  useEffect(() => {
    const fetchData = async () => {

      try {
        const tradeDetail = await fetchTransactionDetails(user, params.id)
        setDataset(tradeDetail)
  
      } catch (e) {
        launchError(t('notifications.payouts.trades.details.error'))
      } finally {
        setLoading(false)
      }
  
    }

    fetchData();
  }, [user, t, params.id])

  return (
    <DashboardLayout page={t("pages_name.trade_details")}>
      <Notification />
      {
        !loading ? (
          <div className='transactions_by_id_box'>
            <div className='transactions_by_id_header'>
              <div className='transactions_by_id_header_name'>
                <h3>Détail de la transaction</h3>
              </div>
            </div>
            <div className='transactions_by_id_items'>
              <div className='transactions_by_id_item_box'>
                <span className='transactions_by_id_item_title'>Client</span>
                <div className='userData_profil'>
                  <img src={`${process.env.REACT_APP_CDN_URL}/usr/pic/${dataset.user_uuid}`} alt="profilepic" className='user_profile_pic' />
                  <div>
                    <a href={`/user/${dataset.user_uuid}`}><p className='user_profil_name'>{dataset.firstName} {dataset.lastName}</p></a>
                  </div>
                </div>
              </div>
              <hr />
              <div className='transactions_by_id_item_box'>
                <span className='transactions_by_id_item_title'>Ticker</span>
                <span className='transactions_by_id_item_content'>{dataset.ticker}</span>
              </div>
              <hr />
              <div className='transactions_by_id_item_box'>
                <span className='transactions_by_id_item_title'>Type</span>
                <span className='transactions_by_id_item_content'>
                  <Badge color={colors.badge[dataset.side]} text={dataset?.side === 'BUY' ? 'ACHAT' : 'VENTE'} />
                </span>
              </div>
              <hr />
              <div className='transactions_by_id_item_box'>
                <span className='transactions_by_id_item_title'>Commission</span>
                <span className='transactions_by_id_item_content'>
                  {/* <p>Plateforme : {dataset.platform_fees}</p>
                  <p>Markup : {dataset.fees}</p> */}
                  <p>{dataset.broker_commission}</p>
                </span>
              </div>
              {/* <hr />
              <div className='transactions_by_id_item_box'>
                <span className='transactions_by_id_item_title'>Status</span>
                <span className='transactions_by_id_item_content'>
                  <Badge color={'grey'} text={dataset.alpaca_status} />
                </span>
              </div> */}
            </div>

            <div className='transactions_by_id_details_wallet'>
              <p className='transactions_by_id_details_title'>Détails :</p>
              <div className='transactions_by_id_details_wallet_box'>
                <div className='transactions_by_id_details_box'>
                  <p className='transactions_by_id_details_p transactions_by_id_details_'><span className='card_trade_details_item_title'>Montant total (+frais) : </span>
                    {dataset.total}
                  </p>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Quantité :</span>{getDecimalValue(dataset?.amount)}</p>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Date de création : </span>
                    {formatDate({ date: dataset.created_at, month: 'long', time: true })}
                  </p>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Date effective : </span>
                    {formatDate({ date: dataset.filled_at, month: 'long', time: true })}
                  </p>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Plus value : </span>
                    {dataset.trader_profit}
                  </p>
                </div>
                {/* <div className='transactions_by_id_details_box'>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Méthode de paiement :</span>{dataset?.method?.toUpperCase()}</p>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Frais de carte (Stripe) :</span>{dataset?.cardFees}</p>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Carte :</span>****{dataset?.cardLast4} - {dataset.cardExp}</p>
                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>ID de paiement carte :</span>
                    <a href={`https://dashboard.stripe.com/payments/${dataset.payment_id}`} target="_blank">{dataset.payment_id}</a>
                  </p>

                  <p className="transactions_by_id_details_p transactions_by_id_details_"><span className='card_trade_details_item_title'>Evaluation de risque carte :</span>
                    {dataset.riskScore} - {dataset.riskLevel}
                  </p>
                </div> */}
              </div>
            </div>
            <div>

            </div>
            <div>

            </div>
          </div>
        ) : (
          <>
            Loading..
          </>
        )
      }
    </DashboardLayout>
  )
}

export default TransactionById